import { useEffect } from 'react';

// Metadados por página. Como o build é pré-renderizado (scripts/prerender.mjs),
// tudo que este hook escreve no <head> é capturado no HTML estático de cada
// rota — ou seja, buscadores e ferramentas de IA leem esses valores sem
// precisar executar JavaScript.

export const SITE_URL = 'https://bysetup.com';
export const SITE_NAME = 'Bysetup';

function upsertMeta(attr, key, content) {
  if (!content) return;

  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertJsonLd(json) {
  let el = document.getElementById('page-jsonld');

  if (!json) {
    if (el) el.remove();
    return;
  }

  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'page-jsonld';
    document.head.appendChild(el);
  }
  el.textContent = json;
}

function toAbsoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return `${SITE_URL}/logo512.png`;
  return pathOrUrl.startsWith('http') ? pathOrUrl : `${SITE_URL}${pathOrUrl}`;
}

export function usePageMeta({ title, description, path = '/', image, type = 'website', jsonLd }) {
  // Serializado aqui para a dependência do efeito ser estável: um objeto
  // literal vindo do componente muda de identidade a cada render.
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const imageUrl = toAbsoluteUrl(image);

    if (title) document.title = title;
    upsertMeta('name', 'description', description);
    upsertCanonical(url);

    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:locale', 'pt_BR');
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', imageUrl);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', imageUrl);

    upsertJsonLd(jsonLdString);
  }, [title, description, path, image, type, jsonLdString]);
}
